var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll_bar_box",style:({ width: _vm.total <= _vm.pageSize ? 0 : _vm.width + 'px', opacity: _vm.visibility == 'visible' ? 1 : 0 })},[_c('div',{staticClass:"scroll_bar",style:({ height: _vm.getScrollHeight() + '%', transform: `translateY(${_vm.getScrollTop()}px)` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }